import { Component } from "react";
import ExtranetInterventions from '../Interventions/ExtranetInterventions'
import { clearComponentsSearch } from "../../redux/componentsPark/componentsParkActions";
import { connect } from "react-redux";
import "./ComponentFound.css";
import { Card, CardContent, CardHeader } from "@mui/material";
import { withRouter } from "react-router";
import { compose } from "redux";
import DetailsTab from "../../components/ComponentsPark/Found/DetailsTab";

class ExtranetComponentPark extends Component {
    constructor(props) {
        super(props);

        if (!this.props.componentPark)
            this.props.history.push("/parks/park");

    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.history.push("/parks");
    }

    componentWillUnmount() {
        this.props.clearComponentsSearch();
    }

    render() {
        if (!this.props.componentPark) return <div></div>;

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <Card className="card">
                    <CardHeader title={this.props.componentPark.complete_name} titleTypographyProps={{ variant: "h4", color: 'primary' }} />
                    <DetailsTab extranet/>
                </Card>
                <Card>
                    <CardHeader title={"Intervention(s) associée(s)"} titleTypographyProps={{ variant: "h5", color: 'primary' }} />
                    <CardContent className="without-side-padding-only-small-screen">
                        <ExtranetInterventions {...this.props} withoutFilters/>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        componentPark: state.componentsPark.currentComponent,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearComponentsSearch: () => dispatch(clearComponentsSearch()),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ExtranetComponentPark);
